export default __webpack_public_path__ + "static/media/3.9d9c0ec4.jpg";